<template>
    <teleport to="body">
        <div class="pop-up-container " :class="{hidden: !showPopUp}">
            <div class="pop-up w-full px-5 md:px-10 py-10">
                <div class="pop-up__content">
                    <span v-if="closable" class="pop-up__close" @click="close">
                        <i class="far fa-times"></i>
                    </span>
                    <slot></slot>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script charset="utf-8">
import Vuex from 'vuex';

export default {
    data() {
        return {

        }
    },

    created() {

    },

    props: {
        closable: {
            default: true
        }
    },

    emits: ['close'],

    computed: {
        ...Vuex.mapGetters('layout', {
            showPopUp: 'showPopUp'
        }),
    },

    methods: {
        ...Vuex.mapMutations('layout', {
            setShowPopUp: 'setShowPopUp'
        }),
        close(){
            this.setShowPopUp(false);
            this.$emit('close');
        }
    }

}
</script>
